import React from 'react';
import { Asset } from '../../../types/asset';
import styled from 'styled-components';

interface FullWidthLinkBlockProps {
    title: string;
    shortDescription: string;
    categoryType: string;
    ctaText: string;
    link: object;
    backgroundImage: Asset;
}

const Container = styled.div`
    border: 1px solid black;
    background-color: #f3eee2;
    max-width: 800px;
    margin: auto;
    `;
const Category = styled.div`
    text-align: center;
    padding: 1rem;
    border-bottom: 1px solid black;
    `;
const ContentWrap =  styled.div`;
    text-align: center;
    padding: 2rem 1rem;

    @media (min-width: 640px) {
        padding: 2rem 6rem;
    }
    @media (min-width: 800px) {
        padding: 3rem 6rem;
    }
    @media (min-width: 1024px) {
        padding: 4rem 8rem;
    }
    `;

const Button = styled.a`
    position: relative;
    text-transform: uppercase;
    font-size: 1rem;

    &::after {
        content: "";
        position: absolute;
        bottom: -2px;
        left: 0;
        right: 0;
        height: 2px;
        background-color: #46ff46;
        transition: all .3s ease-in-out 0s;
        transform: scaleX(1);
    }
`;

export const FullWidthLinkBlock: React.FC<FullWidthLinkBlockProps> = ({
    title,
    shortDescription,
    categoryType,
    ctaText,
    link,
    backgroundImage,
}) => {
    return (
        <div className="pb-8 mb-8 border-b border-black">
            <div
                className={'bg-cover bg-center p-12 md:py-32 lg:py-48 lg:mx-16'}
                style={{ backgroundImage: `url(${backgroundImage.url})` }}
                >
                <Container>
                    <Category><p className="leading-none uppercase text-md">{categoryType}</p></Category>
                    <ContentWrap>
                        <h2 className="mb-4 text-3xl font-semibold lg:text-5xl md:mb-8">{title}</h2>
                        {shortDescription && <p className="mb-4 text-sm md:mb-8">{shortDescription}</p>}

                        <Button href={`/${link}`}>
                            {ctaText}
                        </Button>
                    </ContentWrap>
                </Container>
            </div>
        </div>
    );
};
